export default __webpack_public_path__ + "static/media/30.102d82b5.jpg";